import { render, staticRenderFns } from "./ReceiverAdd.vue?vue&type=template&id=34cb832c"
import script from "./ReceiverAdd.vue?vue&type=script&lang=js"
export * from "./ReceiverAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34cb832c')) {
      api.createRecord('34cb832c', component.options)
    } else {
      api.reload('34cb832c', component.options)
    }
    module.hot.accept("./ReceiverAdd.vue?vue&type=template&id=34cb832c", function () {
      api.rerender('34cb832c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/division/receiver/ReceiverAdd.vue"
export default component.exports